import React from 'react';
import { useModal } from 'react-modal-hook';
import styled from 'styled-components';
import { Banner } from 'components/Banner';
import { theme, toRem } from 'design';
import MaintenanceModeModal from './MaintenanceModeModal';

const StyledBanner = styled(Banner)`
  &:hover {
    cursor: pointer;
    background-color: ${theme.color.warning[50]};
  }
`;

const BannerInner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: ${toRem(1200)};
  gap: ${toRem(theme.space.md)};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  gap: ${toRem(theme.space['2xs'])};
  text-align: center;
  padding: ${toRem(theme.space.xs)} 0;

  @media (min-width: ${theme.breakpoint.small}px) {
    gap: ${toRem(theme.space.xs)};
  }
`;

const Title = styled.span`
  font-weight: ${theme.font.weight.semiBold};
`;

const MaintenanceModeBanner = () => {
  const [showMaintenanceModeModal, hideMaintenanceModeModal] = useModal(() => <MaintenanceModeModal isActive onClose={hideMaintenanceModeModal} />, []);

  return (
    <StyledBanner dataCy="maintenance-mode-banner" appearance="caution" onClick={showMaintenanceModeModal}>
      <BannerInner>
        <TextWrapper>
          <Title>Kickfin is currently performing maintenance. Some features may be temporarily unavailable.</Title>
        </TextWrapper>
      </BannerInner>
    </StyledBanner>
  );
};

export default MaintenanceModeBanner;
